<template>
  <div>
    <div class="weui-mask" role="button" aria-label="关闭弹窗" v-if="dialogMsg"></div>
    <div class="weui-dialog" role="dialog" aria-labelledby="title3" aria-modal="true" v-if="dialogMsg">
      <div class="weui-dialog__hd"><strong class="weui-dialog__title" id="title3">温馨提示</strong></div>
      <div class="weui-dialog__bd">{{dialogMsg}}</div>
      <div class="weui-dialog__ft">
        <a role="button" href="javascript:void 0;" class="weui-dialog__btn weui-dialog__btn_primary"
           @click="confirm">确定</a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex"

export default {
  props: ["dialogMsg"],
  methods: {
    confirm() {
      this.setDialogMsg("")
    },
    ...mapActions(["setDialogMsg"])
  }
}
</script>
